import { ChatBubbleOutlineOutlined as ChatBubbleOutlineIcon } from "@mui/icons-material";
import { ReactNode } from "react";

import { SVG_MUI } from "@ryde/assets";
import { blueGreyMui } from "@ryde/theme";

const SETTINGS_MENU_ICON_SIZE = 16;

const settingsMenuIconColor = blueGreyMui._500;

const svgIconProps = {
  width: SETTINGS_MENU_ICON_SIZE,
  height: SETTINGS_MENU_ICON_SIZE,
  color: settingsMenuIconColor,
};

export const settingsMenuIcons = {
  rides: <SVG_MUI.MenuBusSVG {...svgIconProps} />,
  bookings: <SVG_MUI.MenuCalendarSVG {...svgIconProps} />,
  liveMap: <SVG_MUI.MenuMapSVG {...svgIconProps} />,
  reports: <SVG_MUI.MenuSquarePollSVG {...svgIconProps} />,
  courses: <SVG_MUI.CourseMenu4SVG {...svgIconProps} />,
  passengers: <SVG_MUI.PassengersIconSVG {...svgIconProps} />,
  produceButtons: (
    <SVG_MUI.ProductionSVG
      width={SETTINGS_MENU_ICON_SIZE}
      height={SETTINGS_MENU_ICON_SIZE}
      color={settingsMenuIconColor}
    />
  ),
  feedbacks: (
    <ChatBubbleOutlineIcon
      className="settings-menu-feedback-icon"
      sx={{
        fontSize: SETTINGS_MENU_ICON_SIZE,
        color: settingsMenuIconColor,
      }}
    />
  ),
} satisfies Record<string, ReactNode>;
